import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { EventinfoSearchlistItem } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputText, DisplayEvent, InputDateTime, DateComp, InputInt, ValidatedInt, ValidatedText } from '@/components';
import { type DateType } from '@/utilities/dateutils';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class EventinfoSearchlistItemGuiDef extends GuiDef<EventinfoSearchlistItem> {
    constructor() {
        super('EventinfoSearchlistItem');

        const Name = new FieldDef<EventinfoSearchlistItem>();
        Name.Name = 'Name';
        Name.FieldName = 'Name';
        Name.DefinedFor = 'Both';
        Name.TranslationKey = 'eventinfosearchlistitem.name';
        Name.Editable = true;
        Name.Filterable = true;
        Name.Sortable = true;
        Name.CssClasses = '';
        Name.value = (eventinfosearchlistitem) => eventinfosearchlistitem.Name;
        Name.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.Name = value);
        Name.DetailEditor = markRaw(InputText);
        Name.DetailEditorProps = {};
        Name.CellEditor = markRaw(InputText);
        Name.CellEditorProps = {};
        Name.CellRenderer = markRaw(DisplayEvent);
        Name.CellRendererProps = {};
        Name.Validator = null;
        Name.SortDirection = undefined;
        Name.cellClassRules = undefined;
        Name.MinWidth = 300;
        Name.MaxWidth = undefined;
        Name.Tooltip = null;
        this.Fields.push(Name);

        const Date = new FieldDef<EventinfoSearchlistItem>();
        Date.Name = 'Date';
        Date.FieldName = 'Date';
        Date.DefinedFor = 'Both';
        Date.TranslationKey = 'eventinfosearchlistitem.date';
        Date.Editable = true;
        Date.Filterable = true;
        Date.Sortable = true;
        Date.CssClasses = '';
        Date.value = (eventinfosearchlistitem) => eventinfosearchlistitem.Date;
        Date.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.Date = value);
        Date.DetailEditor = markRaw(InputDateTime);
        Date.DetailEditorProps = { format: 'DATE' as DateType };
        Date.CellEditor = markRaw(InputDateTime);
        Date.CellEditorProps = { format: 'DATE' as DateType };
        Date.CellRenderer = markRaw(DateComp);
        Date.CellRendererProps = { format: 'DATE' as DateType };
        Date.Validator = null;
        Date.SortDirection = undefined;
        Date.cellClassRules = undefined;
        Date.MinWidth = 120;
        Date.MaxWidth = 120;
        Date.Tooltip = null;
        this.Fields.push(Date);

        const NumContestants = new FieldDef<EventinfoSearchlistItem>();
        NumContestants.Name = 'NumContestants';
        NumContestants.FieldName = 'NumContestants';
        NumContestants.DefinedFor = 'Both';
        NumContestants.TranslationKey = 'eventinfosearchlistitem.numcontestants';
        NumContestants.Editable = true;
        NumContestants.Filterable = false;
        NumContestants.Sortable = false;
        NumContestants.CssClasses = '';
        NumContestants.value = (eventinfosearchlistitem) => eventinfosearchlistitem.NumContestants;
        NumContestants.setValue = (eventinfosearchlistitem, value) => {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                value = 0;
            }
            eventinfosearchlistitem.NumContestants = value;
        };
        NumContestants.DetailEditor = markRaw(InputInt);
        NumContestants.DetailEditorProps = {};
        NumContestants.CellEditor = markRaw(InputInt);
        NumContestants.CellEditorProps = {};
        NumContestants.CellRenderer = markRaw(ValidatedInt);
        NumContestants.CellRendererProps = {};
        NumContestants.Validator = null;
        NumContestants.SortDirection = undefined;
        NumContestants.cellClassRules = undefined;
        NumContestants.MinWidth = 115;
        NumContestants.MaxWidth = 115;
        NumContestants.Tooltip = null;
        this.Fields.push(NumContestants);

        const OrganizerName = new FieldDef<EventinfoSearchlistItem>();
        OrganizerName.Name = 'OrganizerName';
        OrganizerName.FieldName = 'OrganizerName';
        OrganizerName.DefinedFor = 'Both';
        OrganizerName.TranslationKey = 'eventinfosearchlistitem.organizername';
        OrganizerName.Editable = true;
        OrganizerName.Filterable = true;
        OrganizerName.Sortable = true;
        OrganizerName.CssClasses = '';
        OrganizerName.value = (eventinfosearchlistitem) => eventinfosearchlistitem.OrganizerName;
        OrganizerName.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.OrganizerName = value);
        OrganizerName.DetailEditor = markRaw(InputText);
        OrganizerName.DetailEditorProps = {};
        OrganizerName.CellEditor = markRaw(InputText);
        OrganizerName.CellEditorProps = {};
        OrganizerName.CellRenderer = markRaw(ValidatedText);
        OrganizerName.CellRendererProps = {};
        OrganizerName.Validator = null;
        OrganizerName.SortDirection = undefined;
        OrganizerName.cellClassRules = undefined;
        OrganizerName.MinWidth = undefined;
        OrganizerName.MaxWidth = undefined;
        OrganizerName.Tooltip = null;
        this.Fields.push(OrganizerName);

        const SportName = new FieldDef<EventinfoSearchlistItem>();
        SportName.Name = 'SportName';
        SportName.FieldName = 'SportName';
        SportName.DefinedFor = 'Both';
        SportName.TranslationKey = 'eventinfosearchlistitem.sportname';
        SportName.Editable = true;
        SportName.Filterable = true;
        SportName.Sortable = true;
        SportName.CssClasses = '';
        SportName.value = (eventinfosearchlistitem) => eventinfosearchlistitem.SportName;
        SportName.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.SportName = value);
        SportName.DetailEditor = markRaw(InputText);
        SportName.DetailEditorProps = {};
        SportName.CellEditor = markRaw(InputText);
        SportName.CellEditorProps = {};
        SportName.CellRenderer = markRaw(ValidatedText);
        SportName.CellRendererProps = {};
        SportName.Validator = null;
        SportName.SortDirection = undefined;
        SportName.cellClassRules = undefined;
        SportName.MinWidth = undefined;
        SportName.MaxWidth = undefined;
        SportName.Tooltip = null;
        this.Fields.push(SportName);

        const FederationName = new FieldDef<EventinfoSearchlistItem>();
        FederationName.Name = 'FederationName';
        FederationName.FieldName = 'FederationName';
        FederationName.DefinedFor = 'Both';
        FederationName.TranslationKey = 'eventinfosearchlistitem.federationname';
        FederationName.Editable = true;
        FederationName.Filterable = true;
        FederationName.Sortable = true;
        FederationName.CssClasses = '';
        FederationName.value = (eventinfosearchlistitem) => eventinfosearchlistitem.FederationName;
        FederationName.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.FederationName = value);
        FederationName.DetailEditor = markRaw(InputText);
        FederationName.DetailEditorProps = {};
        FederationName.CellEditor = markRaw(InputText);
        FederationName.CellEditorProps = {};
        FederationName.CellRenderer = markRaw(ValidatedText);
        FederationName.CellRendererProps = {};
        FederationName.Validator = null;
        FederationName.SortDirection = undefined;
        FederationName.cellClassRules = undefined;
        FederationName.MinWidth = undefined;
        FederationName.MaxWidth = undefined;
        FederationName.Tooltip = null;
        this.Fields.push(FederationName);

        const SportlevelName = new FieldDef<EventinfoSearchlistItem>();
        SportlevelName.Name = 'SportlevelName';
        SportlevelName.FieldName = 'SportlevelName';
        SportlevelName.DefinedFor = 'Both';
        SportlevelName.TranslationKey = 'eventinfosearchlistitem.sportlevelname';
        SportlevelName.Editable = true;
        SportlevelName.Filterable = true;
        SportlevelName.Sortable = true;
        SportlevelName.CssClasses = '';
        SportlevelName.value = (eventinfosearchlistitem) => eventinfosearchlistitem.SportlevelName;
        SportlevelName.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.SportlevelName = value);
        SportlevelName.DetailEditor = markRaw(InputText);
        SportlevelName.DetailEditorProps = {};
        SportlevelName.CellEditor = markRaw(InputText);
        SportlevelName.CellEditorProps = {};
        SportlevelName.CellRenderer = markRaw(ValidatedText);
        SportlevelName.CellRendererProps = {};
        SportlevelName.Validator = null;
        SportlevelName.SortDirection = undefined;
        SportlevelName.cellClassRules = undefined;
        SportlevelName.MinWidth = undefined;
        SportlevelName.MaxWidth = undefined;
        SportlevelName.Tooltip = null;
        this.Fields.push(SportlevelName);

        const DisciplineName = new FieldDef<EventinfoSearchlistItem>();
        DisciplineName.Name = 'DisciplineName';
        DisciplineName.FieldName = 'DisciplineName';
        DisciplineName.DefinedFor = 'Both';
        DisciplineName.TranslationKey = 'eventinfosearchlistitem.disciplinename';
        DisciplineName.Editable = true;
        DisciplineName.Filterable = true;
        DisciplineName.Sortable = true;
        DisciplineName.CssClasses = '';
        DisciplineName.value = (eventinfosearchlistitem) => eventinfosearchlistitem.DisciplineName;
        DisciplineName.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.DisciplineName = value);
        DisciplineName.DetailEditor = markRaw(InputText);
        DisciplineName.DetailEditorProps = {};
        DisciplineName.CellEditor = markRaw(InputText);
        DisciplineName.CellEditorProps = {};
        DisciplineName.CellRenderer = markRaw(ValidatedText);
        DisciplineName.CellRendererProps = {};
        DisciplineName.Validator = null;
        DisciplineName.SortDirection = undefined;
        DisciplineName.cellClassRules = undefined;
        DisciplineName.MinWidth = undefined;
        DisciplineName.MaxWidth = undefined;
        DisciplineName.Tooltip = null;
        this.Fields.push(DisciplineName);

        const ContactPerson = new FieldDef<EventinfoSearchlistItem>();
        ContactPerson.Name = 'ContactPerson';
        ContactPerson.FieldName = 'ContactPerson';
        ContactPerson.DefinedFor = 'Both';
        ContactPerson.TranslationKey = 'eventinfosearchlistitem.contactperson';
        ContactPerson.Editable = true;
        ContactPerson.Filterable = true;
        ContactPerson.Sortable = true;
        ContactPerson.CssClasses = '';
        ContactPerson.value = (eventinfosearchlistitem) => eventinfosearchlistitem.ContactPerson;
        ContactPerson.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.ContactPerson = value);
        ContactPerson.DetailEditor = markRaw(InputText);
        ContactPerson.DetailEditorProps = {};
        ContactPerson.CellEditor = markRaw(InputText);
        ContactPerson.CellEditorProps = {};
        ContactPerson.CellRenderer = markRaw(ValidatedText);
        ContactPerson.CellRendererProps = {};
        ContactPerson.Validator = null;
        ContactPerson.SortDirection = undefined;
        ContactPerson.cellClassRules = undefined;
        ContactPerson.MinWidth = undefined;
        ContactPerson.MaxWidth = undefined;
        ContactPerson.Tooltip = null;
        this.Fields.push(ContactPerson);

        const ContactEmail = new FieldDef<EventinfoSearchlistItem>();
        ContactEmail.Name = 'ContactEmail';
        ContactEmail.FieldName = 'ContactEmail';
        ContactEmail.DefinedFor = 'Both';
        ContactEmail.TranslationKey = 'eventinfosearchlistitem.contactemail';
        ContactEmail.Editable = true;
        ContactEmail.Filterable = true;
        ContactEmail.Sortable = true;
        ContactEmail.CssClasses = '';
        ContactEmail.value = (eventinfosearchlistitem) => eventinfosearchlistitem.ContactEmail;
        ContactEmail.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.ContactEmail = value);
        ContactEmail.DetailEditor = markRaw(InputText);
        ContactEmail.DetailEditorProps = {};
        ContactEmail.CellEditor = markRaw(InputText);
        ContactEmail.CellEditorProps = {};
        ContactEmail.CellRenderer = markRaw(ValidatedText);
        ContactEmail.CellRendererProps = {};
        ContactEmail.Validator = null;
        ContactEmail.SortDirection = undefined;
        ContactEmail.cellClassRules = undefined;
        ContactEmail.MinWidth = undefined;
        ContactEmail.MaxWidth = undefined;
        ContactEmail.Tooltip = null;
        this.Fields.push(ContactEmail);

        const ContactPhone = new FieldDef<EventinfoSearchlistItem>();
        ContactPhone.Name = 'ContactPhone';
        ContactPhone.FieldName = 'ContactPhone';
        ContactPhone.DefinedFor = 'Both';
        ContactPhone.TranslationKey = 'eventinfosearchlistitem.contactphone';
        ContactPhone.Editable = true;
        ContactPhone.Filterable = true;
        ContactPhone.Sortable = true;
        ContactPhone.CssClasses = '';
        ContactPhone.value = (eventinfosearchlistitem) => eventinfosearchlistitem.ContactPhone;
        ContactPhone.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.ContactPhone = value);
        ContactPhone.DetailEditor = markRaw(InputText);
        ContactPhone.DetailEditorProps = {};
        ContactPhone.CellEditor = markRaw(InputText);
        ContactPhone.CellEditorProps = {};
        ContactPhone.CellRenderer = markRaw(ValidatedText);
        ContactPhone.CellRendererProps = {};
        ContactPhone.Validator = null;
        ContactPhone.SortDirection = undefined;
        ContactPhone.cellClassRules = undefined;
        ContactPhone.MinWidth = undefined;
        ContactPhone.MaxWidth = undefined;
        ContactPhone.Tooltip = null;
        this.Fields.push(ContactPhone);

        const CreatedBy = new FieldDef<EventinfoSearchlistItem>();
        CreatedBy.Name = 'CreatedBy';
        CreatedBy.FieldName = 'CreatedBy';
        CreatedBy.DefinedFor = 'Both';
        CreatedBy.TranslationKey = 'eventinfosearchlistitem.createdby';
        CreatedBy.Editable = true;
        CreatedBy.Filterable = true;
        CreatedBy.Sortable = true;
        CreatedBy.CssClasses = '';
        CreatedBy.value = (eventinfosearchlistitem) => eventinfosearchlistitem.CreatedBy;
        CreatedBy.setValue = (eventinfosearchlistitem, value) => (eventinfosearchlistitem.CreatedBy = value);
        CreatedBy.DetailEditor = markRaw(InputText);
        CreatedBy.DetailEditorProps = {};
        CreatedBy.CellEditor = markRaw(InputText);
        CreatedBy.CellEditorProps = {};
        CreatedBy.CellRenderer = markRaw(ValidatedText);
        CreatedBy.CellRendererProps = {};
        CreatedBy.Validator = null;
        CreatedBy.SortDirection = undefined;
        CreatedBy.cellClassRules = undefined;
        CreatedBy.MinWidth = undefined;
        CreatedBy.MaxWidth = undefined;
        CreatedBy.Tooltip = null;
        this.Fields.push(CreatedBy);
    }

    public async LoadDependencies() {}
}
